<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <employee-field
          slot="wr_pleaseman"
          ref="emf"
          label="报告人"
          v-model="form.main.wr_pleaseman"
          @select="onSelectPleaseman($event)"
        />
        <div class="weui-cell" slot="wr_department">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.wr_department || "报告部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <p>{{ form.main.wr_department }}</p>
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="wr_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.wr_type || "报告类别"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.wr_type"
              placeholder="请选择"
            >
              <option>日报</option>
              <option>周报</option>
              <option>月报</option>
            </select>
          </div>
        </div>
        <date-field v-if="form.main.wr_type === '日报'" slot="wr_date" :label="customLabel.wr_date || '报告日期'" v-model="form.main.wr_date" />
        <date-field v-if="form.main.wr_type === '周报'" slot="wr_startdate" :label="customLabel.wr_startdate || '起始日期'" v-model="form.main.wr_startdate" />
        <date-field v-if="form.main.wr_type === '周报'" slot="wr_enddate" :label="customLabel.wr_enddate || '截止日期'" v-model="form.main.wr_enddate" />
        <month-field v-if="form.main.wr_type === '月报'" slot="wr_yearmonth" :label="customLabel.wr_yearmonth || '月报期间'" v-model="form.main.wr_yearmonth" />
        <!-- <employee-check-box :label="'抄送人'" v-model="form.main.wr_ccrecipients" @select="onSelectCcrecipients" /> -->
        <account-check-box :label="'抄送人'" v-model="form.main.wr_ccrecipients" @select="onSelectCcrecipients" />
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells__title">附件</div>
        <div class="weui-cells">
          <file-field v-model="form.main.wr_attach" />
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items1"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>工作总结{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem1(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-cell" slot="wd_matters">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wd_matters || "工作事项" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.wd_matters"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="wd_progress">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wd_progress || "完成进度%" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  min="0"
                  max="100"
                  v-model="item.wd_progress"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="wd_problem">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wd_problem || "工作问题" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.wd_problem"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="wd_measure">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wd_measure || "对策" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.wd_measure"
                  placeholder="请填写"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items1.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem1"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items2"
        :key="'2-' + xindex"
      >
        <div class="weui-cells__title">
          <span>工作计划{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem2(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-cell" slot="wrd_matters">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wrd_matters || "工作事项" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.wrd_matters"
                  placeholder="请填写"
                />
              </div>
            </div>
            <date-field slot="wrd_planbegindate" :label="customLabel.wrd_planbegindate || '计划开始时间'" v-model="item.wrd_planbegindate" />
            <date-field slot="wrd_planenddate" :label="customLabel.wrd_planenddate || '计划完成时间'" v-model="item.wrd_planenddate" />
            <div class="weui-cell" slot="wrd_helpcontent">
              <div class="weui-cell__hd">
                <label for class="weui-label"
                  >{{ customLabel.wrd_helpcontent || "需要协作内容" }}</label
                >
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.wrd_helpcontent"
                  placeholder="请填写"
                />
              </div>
            </div>
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items2.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem2"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import MonthField from "@/components/field/MonthField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import AccountCheckBox from "@/components/field/AccountCheckBox.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    MonthField,
    EmployeeField,
    AccountCheckBox,
    FileField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/workreport",
      codeField: "wr_code",
      statusField: "wr_statuscode",
      caller: "WorkReport",
      xtype: 'oa-workreport-formpanel',
      form: {
        main: {
          wr_type: "日报",
          wr_pleasemancode: null,
          wr_pleasemanid: null,
          wr_pleaseman: null,
          wr_department: null,
          wr_departmentid: null,
          wr_departmentcode: null,
          wr_ccrecipients:null,
          wr_ccrecipientids:null,
        },
        items1: [
          {}
        ],
        items2: [
          {}
        ]
      }
    };
  },
  mounted() {
    const me = this
    if (!me.initId && !me.initData && !me.$route.params.id && !me.$route.query.id) {
      let planId = me.$route.query.plan_id
      if (planId) {
        me.reportByPlan(planId)
      } else {
        me.getCurrentEmployee()
      }
    }
  },
  methods: {
    unSubmit() {
      var me = this,
        id = me.form.main.id;

      me.$loading({
        url: '/api/oa/workreport/unSubmit/' + id,
        method: 'POST'
      }).then(function (res) {
        if (res.success) {
          me.form.main.wr_status = "未审核"
          me.form.main.wr_statuscode = "UNAUDITED"

          me.saveForm()
        }
      }).catch(function () {
          me.$weui.topTips("反提交失败", 3000);
      });
    },
    saveForm() {
      const me = this

      me.$ajax({
        url: "/api/oa/workreport/save?caller=WorkReport",
        method: 'POST',
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.submit(res.data.id)
        }
      }).catch(err => {
        me.$weui.topTips("提交失败", err);
      })
    },
    submit(id) {
      const me = this

      me.$ajax({
        url: "/api/oa/workreport/submit/" + id,
        method: 'POST'
      }).then(res => {
        var editName = me.$route.name,
          readName = editName.substr(0, editName.length - 4);
        if (res.success) {
          // 打开查看页
          me.$router.push({
            name: readName,
            params: {
              id
            }
          });
        }
      })
    },
    getCurrentEmployee() {
      const me = this

      me.$ajax({
        url: "/api/oa/workreport/getLast"
      }).then(res => {
        me.onSelectPleaseman(res.data.main)
      })
    },
    onSelectPleaseman(selection) {
      let main = this.form.main

      main.wr_pleasemancode = selection.applicant.em_code,
      main.wr_pleasemanid = selection.applicant.id,
      main.wr_pleaseman = selection.applicant.em_name

      main.wr_department = selection.applicant.dp_name
      main.wr_departmentid = selection.applicant.em_dpid
      main.wr_departmentcode = selection.applicant.dp_code
      main.wr_ccrecipients = selection.wr_ccrecipients
      main.wr_ccrecipientids = selection.wr_ccrecipientids
    },
    onSelectCcrecipients(selection) {
      let main = this.form.main

      main.wr_ccrecipients = selection.map(item => item.em_name).join(','),
      main.wr_ccrecipientids = selection.map(item => item.id).join(',')
    },
    save() {
      var me = this,
        main = me.form.main;
      if (main.wr_type === '日报' && !main.wr_date) {
        me.$weui.topTips("请选择时间", 2000);
      } else if (main.wr_type === '周报' && (!main.wr_startdate || !main.wr_enddate)) {
        me.$weui.topTips("请选择周报区间", 2000);
      } else if (main.wr_type === '月报' && !main.wr_yearmonth) {
        me.$weui.topTips("请选择月份", 2000);
      } else if (main.id && main.wr_status == '已提交') {

        // 编辑已提交的单据时先反提交，再提交
        me.unSubmit()
      } else {

        // 新增或编辑未提交的单据时先保存单据，再提交
        me.saveForm()
      }
    },
    /**
     * 删除行
     */
    removeItem1(index) {
      var me = this,
        items = me.form.items1;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 删除行
     */
    removeItem2(index) {
      var me = this,
        items = me.form.items2;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem1() {
      var me = this,
        items = me.form.items1;
      items.push({
        
      });
    },
    /**
     * 新增行
     */
    addItem2() {
      var me = this,
        items = me.form.items2;
      items.push({
        
      });
    },
    reportByPlan(planId) {
      const me = this
      me.$ajax({
        url: "/api/oa/workplan/read/" + planId
      }).then(res => {
        let data = res.data
        if (data) {
          me.form = {
            main: {
              id: 0,
              wr_status: '未审核',
              wr_statuscode: 'UNAUDITED',
              wr_date: me.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'),
              wr_pleasemanid: data.em_id,
              wr_pleasemancode: data.em_code,
              wr_pleaseman: data.em_name,
              wr_departmentid: data.dp_id,
              wr_departmentcode: data.dp_code,
              wr_department: data.dp_name,
              wr_type: '日报'
            },
            items1: [{
              id: 0,
              wd_detno: 1,
              wd_matters: data.wp_title
            }],
            items2: [{}]
          }
        }
      })
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>